import ReactHighchart from '../../../../components/Charts/ReactHighchart';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { usePortalAggregations } from '../../myTeamQueries';
import ApiError from '../../../../components/Errors/ApiError';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getActiveCertsChartOptions, getActiveCertsChartData } from '../../utils/chartUtils';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const NoActiveCertificationsEmptyState = () => {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "NO_ACTIVE_CERTIFICATIONS_EMPTY_STATE",
    children: /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "100",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        illustration: "empty-state-charts",
        title: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.overview.certifications.certificationsByTopic.noResultsTitle"
          })
        }),
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.overview.certifications.certificationsByTopic.noResultsDescription"
          })
        })
      })
    })
  });
};
const CertificationsByTopicChart = () => {
  var _portalAggregations$p;
  const {
    portalAggregations,
    portalAggregationsLoading,
    portalAggregationsError
  } = usePortalAggregations();
  if (portalAggregationsLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      inlineSize: "100%",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        minHeight: 364,
        size: "md"
      })
    });
  }
  if (portalAggregationsError || !(portalAggregations !== null && portalAggregations !== void 0 && (_portalAggregations$p = portalAggregations.portalActiveCertificationTopicsTotals) !== null && _portalAggregations$p !== void 0 && _portalAggregations$p.activeCertificationTopicTotals)) {
    return /*#__PURE__*/_jsx(ApiError, {
      error: {
        status: 500
      },
      markerDefault: "CERTIFICATION_TOTALS_BY_TOPIC_API_ERROR"
    });
  }
  if ((portalAggregations === null || portalAggregations === void 0 ? void 0 : portalAggregations.portalActiveCertificationTopicsTotals.activeCertificationTopicTotals.length) === 0) {
    return /*#__PURE__*/_jsx(NoActiveCertificationsEmptyState, {});
  }
  const chartData = getActiveCertsChartData(portalAggregations.portalActiveCertificationTopicsTotals.activeCertificationTopicTotals);
  const options = getActiveCertsChartOptions(chartData);
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    paddingBlockEnd: "100",
    children: /*#__PURE__*/_jsx(ReactHighchart, {
      options: options
    })
  });
};
export default CertificationsByTopicChart;